import { ColumnDef } from "@tanstack/react-table";
import { VoucherTypeResponse } from "@/app/types";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MoreHorizontal, Edit, Trash2, CheckCircle, XCircle } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { DataTableColumnHeader } from "@/components/ui/data-table-column-header"; // Reuse or create specific one

export const columnsVoucherType: ColumnDef<VoucherTypeResponse>[] = [
  { 
    accessorKey: "name", 
    header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
  },
  { 
    accessorKey: "code", 
    header: ({ column }) => <DataTableColumnHeader column={column} title="Code" />,
    cell: ({ row }) => <span className="font-mono">{row.original.code}</span> 
  },
  { 
    accessorKey: "prefix", 
    header: "Prefix", 
    cell: ({ row }) => row.original.prefix || '-' 
  },
  { 
    accessorKey: "suffix", 
    header: "Suffix", 
    cell: ({ row }) => row.original.suffix || '-' 
  },
  {
    accessorKey: "numbering_method",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Numbering" />,
    cell: ({ row }) => <Badge variant="outline" className="capitalize">{row.original.numbering_method}</Badge>,
  },
  {
    accessorKey: "next_number",
    header: "Next No.",
    cell: ({ row }) => (row.original.numbering_method === 'auto' ? row.original.next_number : '-'),
  },
  {
    accessorKey: "affects_stock",
    header: "Affects Stock",
    cell: ({ row }) => row.original.affects_stock ? <CheckCircle className="h-4 w-4 text-green-600" /> : <XCircle className="h-4 w-4 text-muted-foreground" />,
  },
  {
    accessorKey: "affects_accounts",
    header: "Affects Accounts",
    cell: ({ row }) => row.original.affects_accounts ? <CheckCircle className="h-4 w-4 text-green-600" /> : <XCircle className="h-4 w-4 text-muted-foreground" />,
  },
  {
    id: "actions",
    cell: ({ row }) => {
      const voucherType = row.original;
      const dispatchEvent = (eventName: string, detail: VoucherTypeResponse) => {
        document.dispatchEvent(new CustomEvent(eventName, { detail }));
      };
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0"><MoreHorizontal className="h-4 w-4" /></Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => dispatchEvent("edit-voucher-type", voucherType)}>
              <Edit className="mr-2 h-4 w-4" /> Edit
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => dispatchEvent("delete-voucher-type", voucherType)} className="text-destructive">
              <Trash2 className="mr-2 h-4 w-4" /> Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];

// Define filterable columns
export const filterableVoucherTypeColumns = [
  {
    id: "numbering_method",
    title: "Numbering Method",
    options: [
      { value: "auto", label: "Auto" },
      { value: "manual", label: "Manual" },
    ],
  },
  {
    id: "affects_stock",
    title: "Affects Stock",
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
  {
    id: "affects_accounts",
    title: "Affects Accounts",
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
]; 